(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[101],{

/***/ 7425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6492);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(594);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6849);
/* harmony import */ var _JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9373);
/* harmony import */ var _JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Cta_Cta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3499);










var JoinFlowInfoModal = function(param) {
    var isOpen = param.isOpen, tmToken = param.tmToken, idTokenHint = param.idTokenHint;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_3__/* .useUI */ .l)(), uiState = ref5.state, dispatch = ref5.dispatch;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checkIfEmailVerified = ref6[0], setCheckIfEmailVerified = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), verifyEmailFlow = ref7[0], setVerifyEmailFlow = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), ygbActive = ref8[0], setYgbActive = ref8[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
            setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
        }
        if (ygbActive !== window.localStorage.getItem("ygb_active")) {
            setYgbActive(window.localStorage.getItem("ygb_active"));
        }
    }, [
        uiState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (uiState.joinFlowInfoModal.isOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.touchAction = "none";
            document.body.style.width = "100%";
        } else {
            document.body.style.overflow = "auto";
            document.body.style.position = "static";
            document.body.style.touchAction = "";
            document.body.style.width = "unset";
        }
    }, [
        isOpen
    ]);
    var ref9 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .a)({
        queryKey: [
            "verify_email"
        ],
        queryFn: function() {
            return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/tm-auth/verify-email", {
                params: {
                    access_token: tmToken
                }
            });
        },
        enabled: false,
        onSuccess: function() {
            setCheckIfEmailVerified(true);
        }
    }), data = ref9.data, sendVerifyEmailRequest = ref9.refetch;
    (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .a)({
        queryKey: [
            "check_verified_email"
        ],
        queryFn: function() {
            return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/tm-auth/check-email", {
                params: {
                    access_token: tmToken
                }
            });
        },
        enabled: checkIfEmailVerified,
        refetchInterval: checkIfEmailVerified ? 5000 : false,
        onSuccess: function(aData) {
            if (aData.data.data.me.profile.emailConfirmed) {
                setCheckIfEmailVerified(false);
                dispatch({
                    type: "confirmEmail"
                });
                dispatch({
                    type: "openSignupModal"
                });
            }
        }
    });
    if (!isOpen) return null;
    var origin =  true && window.location.origin ? window.location.origin : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModal),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModalContentWrapper),
            children: [
                (uiState.joinFlowInfoModal.modalType === "signup" || uiState.joinFlowInfoModal.modalType === "email" && !data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().closeIcon),
                    style: {
                        fontSize: 26
                    },
                    onClick: function() {
                        if (verifyEmailFlow === "true") {
                            window.localStorage.setItem("verify_email_flow", "false");
                        }
                        if (ygbActive === "true") {
                            window.localStorage.setItem("ygb_active", "false");
                        }
                        window.localStorage.setItem("next_signup_uri", "");
                        if (uiState.joinFlowInfoModal.modalType === "email" && !!tmToken) {
                            router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                        }
                        dispatch({
                            type: "toggleJoinFlowInfoModal",
                            payload: {
                                isOpen: false
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().joinFlowInfoModalContent),
                    children: [
                        uiState.joinFlowInfoModal.modalType === "signup" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                uiState.joinFlowInfoModal.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: uiState.joinFlowInfoModal.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "To join the tournament, please log in with your Trackman account or sign up for a new one."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Go to login",
                                    onClick: function() {
                                        window.localStorage.setItem("ygb_active", "true");
                                        (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.signIn)("trackman");
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && !data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "To sign up for the tournament, you must first verify your email address."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Verify email",
                                    onClick: function() {
                                        return sendVerifyEmailRequest();
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && (data === null || data === void 0 ? void 0 : data.status) === 200 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Verification email sent to",
                                        "".concat((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profile) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sendEmailConfirmation) === null || ref4 === void 0 ? void 0 : ref4.email) ? " " + data.data.data.me.profile.sendEmailConfirmation.email : " your trackman email address"),
                                        ". Check your inbox and follow the instructions."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Once confirmed, you'll be redirected to the next step. To stop sign up, click the button below."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Close",
                                    onClick: function() {
                                        window.localStorage.setItem("verify_email_flow", "false");
                                        window.localStorage.setItem("ygb_active", "false");
                                        window.localStorage.setItem("next_signup_uri", "");
                                        dispatch({
                                            type: "toggleJoinFlowInfoModal",
                                            payload: {
                                                isOpen: false
                                            }
                                        });
                                        router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                                    }
                                })
                            ]
                        }),
                        uiState.joinFlowInfoModal.modalType === "email" && data && data.status !== 200 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Ooops... something went wrong. Please try again"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    className: (_JoinFlowInfoModal_module_css__WEBPACK_IMPORTED_MODULE_8___default().cta),
                                    name: "Close",
                                    onClick: function() {
                                        window.localStorage.setItem("verify_email_flow", "false");
                                        window.localStorage.setItem("ygb_active", "false");
                                        window.localStorage.setItem("next_signup_uri", "");
                                        dispatch({
                                            type: "toggleJoinFlowInfoModal",
                                            payload: {
                                                isOpen: false
                                            }
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JoinFlowInfoModal);


/***/ }),

/***/ 6290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6617);
/* harmony import */ var _SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Cta_Cta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3499);





var SignupModal = function(param) {
    var isOpen = param.isOpen, tmToken = param.tmToken, idTokenHint = param.idTokenHint;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), paymentComplete = ref[0], setPaymentComplete = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), nextSignupUri = ref1[0], setNextSignupUri = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var origin =  true && window.location.origin ? window.location.origin : "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (nextSignupUri !== window.localStorage.getItem("next_signup_uri")) {
            setNextSignupUri(window.localStorage.getItem("next_signup_uri"));
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ygbEventListener = function(args) {
            if (args.origin === "https://booking.trackmangolf.com") {
                if (args.data.eventType.toLowerCase() === "purchasemade") {
                    setPaymentComplete(true);
                }
            }
        };
        window.addEventListener("message", ygbEventListener);
        return function() {
            window.removeEventListener("message", ygbEventListener);
        };
    }, [
        idTokenHint
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.touchAction = "none";
        } else {
            document.body.style.overflow = "auto";
            document.body.style.position = "static";
            document.body.style.touchAction = "";
        }
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().signupModal),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().signupModalNav),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "CLOSE",
                    onClick: function() {
                        window.localStorage.setItem("verify_email_flow", "false");
                        window.localStorage.setItem("ygb_active", "false");
                        window.localStorage.setItem("next_signup_uri", "");
                        router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                    },
                    className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().backButton)
                })
            }),
            !paymentComplete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                width: "100%",
                height: "100%",
                src: "".concat(nextSignupUri, "?tm-token=").concat(tmToken, "&embedded=true&hideBookingNav=true&autoProceed=true&hideCheckoutHeader=true")
            }),
            paymentComplete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().successWrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().successContent),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: "Welcome to the NEXT Golf Tour!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Your spot in the upcoming round is now confirmed."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "For all the details you need to ace your game, please review the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://www.nextgolftour.com/players-guide",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "Players guide"
                                    })
                                }),
                                "—it's packed with essential information and pro tips."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "Need a hand? Our Help Center is just a click away.",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://trackmangolf.zendesk.com/hc/en-us/categories/11965023457179-Tournaments",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "Visit help center"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Tee off with confidence—we're eager to see you showcase your skills!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "— The NEXT Golf Tour Team"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Cta_Cta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            name: "Back to home page",
                            onClick: function() {
                                window.localStorage.setItem("verify_email_flow", "false");
                                window.localStorage.setItem("ygb_active", "false");
                                window.localStorage.setItem("next_signup_uri", "");
                                router.push("https://login.trackmanrange.com/connect/endsession?id_token_hint=".concat(idTokenHint, "&post_logout_redirect_uri=").concat(origin));
                            },
                            className: (_SignupModal_module_css__WEBPACK_IMPORTED_MODULE_4___default().backButton)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignupModal);


/***/ }),

/***/ 3778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useStartSignup; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6849);



var useStartSignup = function() {
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)(), session = ref.data, status = ref.status;
    var ref1 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_2__/* .useUI */ .l)(), uiState = ref1.state, dispatch = ref1.dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (status === "authenticated" && session.accessToken && uiState.isEmailVerified) {
            dispatch({
                type: "openSignupModal"
            });
        }
    }, [
        status,
        uiState.isEmailVerified
    ]);
};


/***/ }),

/***/ 6374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useStartVerifyEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(414);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6849);






var useStartVerifyEmail = function() {
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)(), session = ref.data, status = ref.status;
    var ref1 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_3__/* .useUI */ .l)(), uiState = ref1.state, dispatch = ref1.dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (status === "authenticated" && session.accessToken && !uiState.isEmailVerified) {
            window.localStorage.setItem("verify_email_flow", "true");
            var fetchData = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, data;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/tm-auth/check-email", {
                                        params: {
                                            access_token: session.accessToken
                                        }
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.profile) === null || ref2 === void 0 ? void 0 : ref2.emailConfirmed) {
                                    dispatch({
                                        type: "confirmEmail"
                                    });
                                    window.localStorage.setItem("verify_email_flow", "false");
                                }
                                if (!(data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.me) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.profile) === null || ref5 === void 0 ? void 0 : ref5.emailConfirmed)) {
                                    dispatch({
                                        type: "toggleJoinFlowInfoModal",
                                        payload: {
                                            isOpen: true,
                                            modalType: "email"
                                        }
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchData() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchData();
        }
    }, [
        status,
        uiState.isEmailVerified
    ]);
};


/***/ }),

/***/ 5473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useTmSignOut; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6849);



var useTmSignOut = function() {
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), session = ref.data;
    var ref1 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_2__/* .useUI */ .l)(), uiState = ref1.state;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((session === null || session === void 0 ? void 0 : session.accessToken) && window.localStorage.getItem("ygb_active") === "false" && window.localStorage.getItem("verify_email_flow") === "false") {
            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                redirect: false
            });
        }
    }, [
        session,
        uiState
    ]);
};


/***/ }),

/***/ 9373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"joinFlowInfoModal":"JoinFlowInfoModal_joinFlowInfoModal__zEgHB","joinFlowInfoModalContentWrapper":"JoinFlowInfoModal_joinFlowInfoModalContentWrapper__E8Ymp","closeIcon":"JoinFlowInfoModal_closeIcon__g1LQB","joinFlowInfoModalContent":"JoinFlowInfoModal_joinFlowInfoModalContent__ZNfdO","cta":"JoinFlowInfoModal_cta__g533Z"};

/***/ }),

/***/ 6617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signupModal":"SignupModal_signupModal__T3aNp","signupModalNav":"SignupModal_signupModalNav__tfNOm","backButton":"SignupModal_backButton__066sK","successWrapper":"SignupModal_successWrapper__ZUsVb","successContent":"SignupModal_successContent___sUW1"};

/***/ })

}]);